export default {
    props: {
        attribution: {
            type: String,
            default: undefined,
            kComposite: 'attribution'
        },
        autoBind: {
            type: Boolean,
            default: undefined,
            kComposite: 'autoBind'
        },
        dataSource: {
            type: [Object, Array],
            default: undefined,
            kComposite: 'dataSource'
        },
        extent: {
            type: Array,
            default: undefined,
            kComposite: 'extent'
        },
        apiKey: {
            type: String,
            default: undefined,
            kComposite: 'key'
        },
        imagerySet: {
            type: String,
            default: undefined,
            kComposite: 'imagerySet'
        },
        culture: {
            type: String,
            default: undefined,
            kComposite: 'culture'
        },
        locationField: {
            type: String,
            default: undefined,
            kComposite: 'locationField'
        },
        shape: {
            type: String,
            default: undefined,
            kComposite: 'shape'
        },
        tileSize: {
            type: Number,
            default: undefined,
            kComposite: 'tileSize'
        },
        titleField: {
            type: String,
            default: undefined,
            kComposite: 'titleField'
        },
        tooltipAutoHide: {
            type: Boolean,
            default: undefined,
            kComposite: 'tooltip.autoHide'
        },
        tooltipAnimationCloseEffects: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.animation.close.effects'
        },
        tooltipAnimationCloseDuration: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.animation.close.duration'
        },
        tooltipAnimationOpenEffects: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.animation.open.effects'
        },
        tooltipAnimationOpenDuration: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.animation.open.duration'
        },
        tooltipContent: {
            type: [String, Function],
            default: undefined,
            kComposite: 'tooltip.content'
        },
        tooltipContentUrl: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.content.url'
        },
        tooltipTemplate: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.template'
        },
        tooltipCallout: {
            type: Boolean,
            default: undefined,
            kComposite: 'tooltip.callout'
        },
        tooltipIframe: {
            type: Boolean,
            default: undefined,
            kComposite: 'tooltip.iframe'
        },
        tooltipHeight: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.height'
        },
        tooltipWidth: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.width'
        },
        tooltipPosition: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.position'
        },
        tooltipShowAfter: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.showAfter'
        },
        tooltipShowOn: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.showOn'
        },
        maxSize: {
            type: Number,
            default: undefined,
            kComposite: 'maxSize'
        },
        minSize: {
            type: Number,
            default: undefined,
            kComposite: 'minSize'
        },
        opacity: {
            type: Number,
            default: undefined,
            kComposite: 'opacity'
        },
        subdomains: {
            type: Array,
            default: undefined,
            kComposite: 'subdomains'
        },
        symbol: {
            type: [String, Function],
            default: undefined,
            kComposite: 'symbol'
        },
        type: {
            type: String,
            default: undefined,
            kComposite: 'type'
        },
        styleFillColor: {
            type: String,
            default: undefined,
            kComposite: 'style.fill.color'
        },
        styleFillOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'style.fill.opacity'
        },
        styleStrokeColor: {
            type: String,
            default: undefined,
            kComposite: 'style.stroke.color'
        },
        styleStrokeDashType: {
            type: Number,
            default: undefined,
            kComposite: 'style.stroke.dashType'
        },
        styleStrokeOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'style.stroke.opacity'
        },
        styleStrokeWidth: {
            type: Number,
            default: undefined,
            kComposite: 'style.stroke.width'
        },
        urlTemplate: {
            type: String,
            default: undefined,
            kComposite: 'urlTemplate'
        },
        valueField: {
            type: String,
            default: undefined,
            kComposite: 'valueField'
        },
        zIndex: {
            type: Number,
            default: undefined,
            kComposite: 'zIndex'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-map-vue-wrapper/src/KendoMapLayer/LayerProps.js